import React, { useRef, useState } from 'react';

import videoSrc from '../../assets/img/Syrol 02 .mp4';
import icon1 from '../../assets/img/choose/home12/icon/1.png';
import icon2 from '../../assets/img/choose/home12/icon/2.png';
import icon3 from '../../assets/img/choose/home12/icon/3.png';

import bgImg from '../../assets/img/bg/home12/why-learn-bg.jpg';

const bgStyle = {
    backgroundImage:`url(${bgImg})`
}

const WhyChooseUs = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            videoRef.current.muted = false;
            setIsPlaying(true);
        }
    };

    return (
        <div className="why-choose-us style3" style={bgStyle}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 md-mb-40">
                        <div className="img-part" style={{ position: 'relative' }}>
                            <video
                                ref={videoRef}
                                src={videoSrc}
                                controls
                                loop
                                style={{ width: '100%', maxHeight: '700px', borderRadius: '8px', objectFit: 'cover' }}
                                alt="Syrol Video"
                            />
                            {!isPlaying && (
                                <div
                                    onClick={handlePlay}
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        cursor: 'pointer',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        borderRadius: '50%',
                                        width: '60px',
                                        height: '60px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontSize: '24px'
                                    }}
                                >
                                    <i className="fa fa-play"></i>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-6 pl-60 md-pl-14">
                        <div className="sec-title3 mb-30">
                            <h2 className=" title new-title margin-0 pb-14">Join the Syrol Advantage</h2>
                            <div className="new-desc">Discover how our innovative software development and expert maintenance services can transform your business</div>
                        </div>
                        <div className="services-part mb-20">
                            <div className="services-icon">
                                <img src={icon1} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title">Personalized Approach</h2>
                                <p className="services-txt">Understanding unique business needs and goals </p>
                            </div>
                        </div> 
                        <div className="services-part mb-20">
                            <div className="services-icon">
                                <img src={icon2} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title"> Quality Assurance</h2>
                                <p className="services-txt">Rigorous security and performance testing and quality control processes.</p>
                            </div>
                        </div> 
                        <div className="services-part mb-20">
                            <div className="services-icon">
                                <img src={icon1} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title">Technical Expertise</h2>
                                <p className="services-txt">In-depth knowledge of latest technologies and frameworks. </p>
                            </div>
                        </div> 
                        <div className="services-part">
                            <div className="services-icon">
                                <img src={icon3} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title">Continuous Improvement</h2>
                                <p className="services-txt">Regular updates and maintenance for optimal performance</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyChooseUs;